var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 3.9001H20.6C20.8387 3.9001 21.0676 3.99492 21.2364 4.1637C21.4052 4.33248 21.5 4.5614 21.5 4.8001V19.2001C21.5 19.4388 21.4052 19.6677 21.2364 19.8365C21.0676 20.0053 20.8387 20.1001 20.6 20.1001H4.4C4.16131 20.1001 3.93239 20.0053 3.7636 19.8365C3.59482 19.6677 3.5 19.4388 3.5 19.2001V4.8001C3.5 4.5614 3.59482 4.33248 3.7636 4.1637C3.93239 3.99492 4.16131 3.9001 4.4 3.9001H8V2.1001H9.8V3.9001H15.2V2.1001H17V3.9001ZM5.3 9.3001V18.3001H19.7V9.3001H5.3ZM7.1 12.9001H11.6V16.5001H7.1V12.9001Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.2228551872259b9373727a26aed925ec.svg";
export { ForwardRef as ReactComponent };